import { SearchPageState } from "../searchPage/searchPageState";

export interface SearchModalProps {
  isOpen: boolean
  toggleSearchModal: () => void
  setSearchPageState: (newState: Partial<SearchPageState>, cb?: () => void) => void
  runNewQuery: (query: string) => void
}

export interface SearchModalState {
  searchQuery: string
}

export const initialState: SearchModalState = { searchQuery: "" }

export type SearchModalLayoutProps = SearchModalProps & SearchModalState & {
  updateQuery: (query: string) => void
  runSearch: () => void
}